import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import EnhancedTable from './tableComponent/EnhancedTable';

//import service
import EmployerService from "../../../services/EmployerService";
import Spinner from "reactjs-simple-spinner";
import {toast, ToastContainer} from "react-toastify";


const Employers = (props) => {
    const [activateLoading, setActivateLoading] = useState(false);
    const [deactivateLoading, setDeactivateLoading] = useState(false);




    //open edit form
    const openEditForm = (value) => {
        //store row record into localStorage
        localStorage.setItem('employerId',JSON.stringify(value));
        props.history.push('/edit-employer');
    }

    //open representatives
    const openRepresentatives = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('employerId',JSON.stringify(value));
        props.history.push('/representatives');

    }

    const activate = (id) => {
        setActivateLoading(true);
        //call activate endpoint
        EmployerService.activate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' Aggregator Activated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                let token = JSON.parse(localStorage.getItem('token'));
                EmployerService.getAllEmployers().then(response => {
                    console.log(response);
                    setData(response);
                    setActivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setActivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                 toast.warning('Operation failed: ' + err, {
                     position: "top-center",
                     autoClose: 5000,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                 });
                setActivateLoading(false);
            })

    }

    const deactivate = (id) => {
        setDeactivateLoading(true)
        //call deactivate endpoint
        EmployerService.deactivate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' Aggregator Deactivated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                let token = JSON.parse(localStorage.getItem('token'));
                EmployerService.getAllEmployers().then(response => {
                    console.log(response);
                    setData(response);
                    setDeactivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setDeactivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setDeactivateLoading(false)
            })
    }
// eslint-disable-next-line
    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: 'id'
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Contact Number',
                accessor: 'contact_number',
            },
            {
                Header: 'Address',
                Cell: ({row}) => (
                    <span>
                        <label>
                              {row.original.street}
                        </label><br/>
                        <label>
                              {row.original.suburb}
                        </label><br/>
                        <label>
                             {row.original.city}
                        </label>
                    </span>
                )
            },
            {
                Header: 'Postal Address',
                Cell: ({row}) => (
                    <span>
                        <label>
                              {row.original.postal_address_street}
                        </label><br/>
                        <label>
                              {row.original.postal_address_suburb}
                        </label><br/>
                        <label>
                             {row.original.postal_address_city}
                        </label>
                    </span>
                )
            },
            {
                Header: 'Action',
                accessor: 'status',
                Cell: ({value}) => (
                    <span>
                        {value === '0' ? (
                            <label className="badge badge-danger p-2" htmlFor="">Deactivated</label>
                        ) : (
                            <label className="badge badge-success p-2" htmlFor="">Active</label>
                        )}
                    </span>
                )
            },
            {
                Header: 'Action',
                Cell: ({row}) => (
                    <span>
 <Link className="btn btn-sm btn-primary " onClick={() => openEditForm(row.original.id)}>Edit <i
     className="fa fa-edit"/></Link>
            <span> | </span>
            <Link className="btn btn-sm btn-secondary"
                  onClick={() => openRepresentatives(row.original.id)}> Representatives</Link>  <span> | </span>
                        {row.original.status == '1' ? (
                            <Link className="btn btn-sm btn-danger"
                                  onClick={() => deactivate(row.original.id)}>Deactivate&nbsp;<i
                                className="fa fa-power-off"/></Link>
                        ) : (
                            <Link className="btn btn-sm btn-success"
                                  onClick={() => activate(row.original.id)}>Activate &nbsp;<i
                                className="fa fa-check-circle"/></Link>
                        )}

                    </span>
                )
            },
        ],
        []
    )


    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // till here end
    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);

        EmployerService.getAllEmployers().then(response => {
            console.log('aggr', response);
            if (response !== null || response !== undefined) {
                setData(response);
                setLoading(false);
            } else if (response.status === 401) {
                setData([])
                setLoading(false);
            } else {
                setData([])
                setLoading(false);
            }

        }).catch(err => {
            setData([])
            console.log(err);
            setLoading(false);
            toast.warning('Failed to get all aggregators')
        });

    }, []);

    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{color: "white"}}
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="getting aggregators....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {activateLoading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Activating....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {deactivateLoading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Deactivating....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && !activateLoading && !deactivateLoading && (
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                &nbsp;|&nbsp;
                                Aggregators
                            </ul>
                            <div className="row mt">
                                <div className="card col-lg-12">
                                    <div className="content-panel bg-white">
                                        <div id="table">
                                            {/*    aggregators table*/}
                                            <CssBaseline/>
                                            <EnhancedTable
                                                columns={columns}
                                                data={data}
                                                setData={setData}
                                                updateMyData={updateMyData}
                                                skipPageReset={skipPageReset}
                                            />
                                            {/* End */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Employers;
